import { render, staticRenderFns } from "./ViewerAbstract.vue?vue&type=template&id=637a34f5&scoped=true&"
import script from "./ViewerAbstract.vue?vue&type=script&lang=js&"
export * from "./ViewerAbstract.vue?vue&type=script&lang=js&"
import style0 from "./ViewerAbstract.vue?vue&type=style&index=0&id=637a34f5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637a34f5",
  null
  
)

export default component.exports